import { createAction, createAsyncAction } from "typesafe-actions";

import type { FetchError } from "app/pages/sales-intelligence/types";

import type {
    SuppressionList,
    CompanyParsingErrors,
    ParseDomainsResult,
    CreateSuppressionListStep,
} from "../../components/types";

export const setCreateListStep = createAction(
    "@@si/management/suppression-list/SET_CREATE_LIST_STEP",
)<CreateSuppressionListStep>();

export const parseListAsync = createAsyncAction(
    "@@si/management/suppression-list/PARSE_SL_LIST_START",
    "@@si/management/suppression-list/PARSE_SL_LIST_SUCCESS",
    "@@si/management/suppression-list/PARSE_SL_LIST_FAILURE",
)<void, ParseDomainsResult, Partial<CompanyParsingErrors>>();

export const fetchSuppressionListsAsync = createAsyncAction(
    "@@si/management/suppression-list/FETCH_LISTS_START",
    "@@si/management/suppression-list/FETCH_LISTS_SUCCESS",
    "@@si/management/suppression-list/FETCH_LISTS_FAILURE",
)<void, SuppressionList[], FetchError>();

export const sendParsedAsync = createAsyncAction(
    "@@si/management/suppression-list/SEND_PARSED_SL_LIST_START",
    "@@si/management/suppression-list/SEND_PARSED_SL_LIST_SUCCESS",
    "@@si/management/suppression-list/SEND_PARSED_SL_LIST_FAILURE",
)<void, SuppressionList, FetchError>();

export const deleteListAsync = createAsyncAction(
    "@@si/management/suppression-list/DELETE_SL_LIST_START",
    "@@si/management/suppression-list/DELETE_SL_LIST_SUCCESS",
    "@@si/management/suppression-list/DELETE_SL_LIST_FAILURE",
)<void, void, FetchError>();

export const resetSuppressionListErrors = createAction("@@si/management/suppression-list/RESET_ERRORS")<void>();

export const resetParsedList = createAction("@@si/management/suppression-list/RESET_PARSED_LIST")<void>();
